module.exports = __webpack_public_path__ + "img/cone_pt_hex_setsku.prt.f35073e8.jpg";